import {
  Component,
  EventEmitter,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {
  SessionService,
  HttpService,
  MessageService,
  FunctionsService,
  fileInputParams,
  CombosConfiguration,
  LocalStorageService,
  MenuBreadCrumb,
} from 'brainloper-ui';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { UserServiceService } from 'app/services/user-service.service';
import { ModalTypesComponent } from '../../../../shared/modals-types/modal-types.component';
import { User } from 'app/models2/administration/user';
import { ValidateIfUserExists } from 'app/models2/administration/validateIfUserExists';
import { ValidateIfEmailExists } from 'app/models2/administration/validateIfEmailExists';

export class DatepickerCustomIconExample {}

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss'],
})
export class UserDetailComponent implements OnInit, OnChanges {


  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
      name:"Usuarios",
      router:'/administracion/usuarios',
    },
    {
    name:"Detalle",
    current:true
    }
  ]

  private profilePicture: string;
  private curriculumVitae: string;
  private fotoPH: string;
  private cvPH: string;
  public companyId = this.storage.get<number>('companyId')
  public hide: boolean = true;

  private urlGetAreas: string = `${EndpointDictionary.Area.AREA_COMBO}`;
  private urlGetCargos: string = `${EndpointDictionary.Position.POSITION_COMBO}`;
  private urlGetPaises: string = `${EndpointDictionary.Contry.COUNTRY_COMBO}`;
  private urlGetRegion: string = `${EndpointDictionary.Region.REGION_COMBO}`;
  private urlGetCity: string = `${EndpointDictionary.City.CITY_COMBO}`;
  private urlGetSexo: string = `${EndpointDictionary.Gender.GENDER_COMBO}`;
  private urlGetEps: string = `${EndpointDictionary.EPS.EPS_COMBO}`;
  private urlGetArl: string = `${EndpointDictionary.ARL.ARL_COMBO}`;
  private urlGetTipoSangre: string = `${EndpointDictionary.BloodType.BLOOD_COMBO}`;
  private urlGetRoles: string = `${EndpointDictionary.Role.ROLE_COMBO}`;
  private inactivateUser: string = `${EndpointDictionary.User.INACTIVATE_USER}`;
  private activeUser: string = `${EndpointDictionary.User.ACTIVE_USER}`;



  public tipoRedireccion: string;
  public movil: any;
  //compani:Company = new Company()

  public validateIfUserExists = new ValidateIfUserExists();
  public validateIfEmailExists = new ValidateIfEmailExists();
  public hasEmailDuplicateError: boolean = false;


  public userForm: UntypedFormGroup;

  private files = {
    photo: null,
    cv: null,
  };

  //Foto
  public fileInput: fileInputParams = {
    typeFile: 'imagen',
    input: 'formulario',
    label: 'foto',
    edit: true,
    style: {
      width: '100%',
    },
  };
  public fileInputCv: fileInputParams = {
    typeFile: 'pdf',
    input: 'formulario',
    label: 'CV',
    edit: true,
    style: {
      width: '100%',
    },
  };

  public reloadComboRole = new EventEmitter<any>();
  public combosConfigRole: CombosConfiguration = {
    visibleField: 'rol',
    selectionField: 'id',
    urlCombo:this.urlGetRoles,
    label: 'Rol',
  };

  public reloadComboArea = new EventEmitter<any>();
  public combosConfigArea: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: this.urlGetAreas,
    label: 'Area',
  };

  public reloadComboPosition = new EventEmitter<any>();
  public combosConfigPosition: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: this.urlGetCargos,
    label: 'Cargo',
  };

  public reloadComboCountry = new EventEmitter<any>();
  public combosConfigCountry: CombosConfiguration = {
    visibleField: 'country',
    selectionField: 'id',
    urlCombo: this.urlGetPaises,
    label: 'Pais',
  };

  public reloadComboRegion = new EventEmitter<any>();
  public combosConfigRegion: CombosConfiguration = {
    visibleField: 'region',
    selectionField: 'id',
    label: 'Departamento',
  };

  public reloadComboCity = new EventEmitter<any>();
  public combosConfigCity: CombosConfiguration = {
    visibleField: 'city',
    selectionField: 'id',
    label: 'ciudad',
  };

  public reloadComboArl = new EventEmitter<any>();
  public combosConfigArl: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: this.urlGetArl,
    label: 'ARL',
  };

  public reloadComboEps = new EventEmitter<any>();
  public combosConfigEps: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: this.urlGetEps,
    label: 'EPS',
  };
  public reloadComboBlood = new EventEmitter<any>();
  public combosConfigBlood: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    urlCombo: this.urlGetTipoSangre,
    label: 'Tipo de Sangre',
  };

  public reloadComboGender = new EventEmitter<any>();
  public combosConfigGender: CombosConfiguration = {
    visibleField: 'gender',
    selectionField: 'id',
    urlCombo: this.urlGetSexo,
    label: 'Sexo',
  };

  private user: User;

  constructor(
    private session: SessionService,
    private http: HttpService,
    private message: MessageService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private functionEter: FunctionsService,
    public deleteItem: DeleteGenericService,
    public userService: UserServiceService,
    private storage : LocalStorageService
  ) {
    this.userForm = this.formBuilder.group({
      userId: null,
      name: '',
      photo: 'null',
      areaId: '',
      jobTitleId: '',
      epsId: '',
      arlId: '',
      bloodTypeId: 0,
      user: 0,
      password: '',
      email: ['', [Validators.email]],
      phone: 0,
      emergencyContact: '',
      emergencyContactPhone: 0,
      countryId: 0,
      regionId: 0,
      cityId: 0,
      address: '',
      genderId: 0,
      cv: 'null',
      dateJoining: '',
      roleId: '',
    });
    this.message.openLoading('Cargando', 'Cargando Información');
  }



  async ngOnInit() {
    this.tipoRedireccion = this.session.getData('redireccion');
    this.movil = screen.width > 600 ? false : true;
    this.inicializarCombos();

    if (this.tipoRedireccion == 'actualizar') {
        await this.inicializarCampos();
    }

    this.setupEmailValidators();
  }

  ngOnChanges(changes: SimpleChanges) {}

  public async userChanged(user: string) {
    if (user.length > 2) {
      this.validateIfUserExists = await this.userService.validateUser(user);

      if (this.validateIfUserExists.userExists) {
        this.userForm.controls.password.setValue('xxxxxxxxx');
      } else {
        this.userForm.controls.password.setValue(null);
      }

      if(this.validateIfUserExists.userExistsInCurrentCompany){
        this.userForm.controls.user.setValue(null);
        this.userForm.controls.password.setValue(null);
      }
    }
  }

  async saveUser(form:User) {   
    if (form.email && form.email.trim() !== '') {
      const currentUserId = this.tipoRedireccion === 'actualizar' ? this.user?.userId : undefined;
      const emailValidation = await this.userService.validateEmail(form.email, currentUserId, true);
      
      if (emailValidation.emailExists) {
        const emailControl = this.userForm.get('email');
        const existingErrors = emailControl?.errors || {};
        emailControl?.setErrors({ ...existingErrors, emailExists: true });
        return;
      }
    }

    let date: Date = new Date(form.dateJoining);
    let ingreso: string = `${date.getFullYear()}/${
      date.getMonth() + 1
    }/${date.getDate()}`;

    form.dateJoining = ingreso;

    if (this.tipoRedireccion == 'actualizar') {
      form.password = null
      await this.userService.updateUser(
        form,
        this.files,
        this.fotoPH,
        this.cvPH
      );
    } else {
      let user = new User()
      user = form as User
      await this.userService.addUser(user, this.files);
    }
  }

  errorMessage() {
    this.message.Error('Error!', 'Debe completar los campos del formulario');
  }

  inicializarCombos() {
    if (this.tipoRedireccion == 'nuevo') {
      setTimeout(() => {
        this.message.closeLoading();
      }, 500);
    }
  }

  async inicializarCampos() {
    this.user = this.session.getData('usuarioData');
    for (let controls of Object.keys(this.userForm.controls)) {
      if(this.user[controls]){
        this.userForm.controls[controls].setValue(this.user[controls]);
      }
    }

    let date = this.functionEter.dateIso(this.user.dateJoining)
    this.userForm.controls.dateJoining.setValue(`${date}T08:00:00.000Z`)

    this.combosConfigCountry.selected = this.user.countryId;

    this.fotoPH = this.user.photo;
    this.cvPH = this.user.cv;

    this.files.photo = this.user.photo;
    this.files.cv = this.user.cv;

    this.profilePicture = `${EndpointDictionary.Base._BASE_URL_V2}${this.user.photo}/${this.companyId}`;
    this.curriculumVitae = `${EndpointDictionary.Base._BASE_URL_V2}${this.user.cv}/${this.companyId}`;

    this.fileInput.label = this.fotoPH;
    this.fileInputCv.label = this.cvPH;

    this.changesCountry(this.user.countryId);
    this.changesRegion(this.user.regionId);
    
    this.setupEmailValidators();
    
    setTimeout(() => {
      this.message.closeLoading();
    }, 500);
  }

  changesCountry($event: number) {
    if ($event && $event > 0) {
      this.userForm.controls.countryId.setValue($event);
      this.combosConfigRegion.urlCombo = `${this.urlGetRegion}/${$event}`;
      this.reloadComboRegion.emit();
      if (this.tipoRedireccion == 'actualizar') {
        this.combosConfigRegion.selected = this.user.regionId;
      }
    }
  }
  changesRegion($event: number) {
    if ($event && $event > 0) {
      this.userForm.controls.regionId.setValue($event);
      this.combosConfigCity.urlCombo = `${this.urlGetCity}/${$event}`;
      this.reloadComboCity.emit();
      if (this.tipoRedireccion == 'actualizar') {
        this.combosConfigCity.selected = this.user.cityId;
      }
    }
  }

  async deleteUser($event) {
    $event.preventDefault();
    let arrayDelete: Array<User> = [];
    arrayDelete.push(this.user);
    let res = await this.deleteItem.inactivateOrActivate(arrayDelete, false, this.activeUser, this.inactivateUser, 'Usuario')

    if (res) {
      this.router.navigate(['administracion/usuarios']);
    }
  }

  addNew(type) {
    let size: number = screen.width > 500 ? 60 : 50;

    const dialogRef = this.dialog.open(ModalTypesComponent, {
      width: `${size}vh`,
      data:  {name:type},
    });

    dialogRef.afterClosed().subscribe((result) => {
      switch (type) {
        case 'area':
          this.reloadComboArea.emit();
          break;
        case 'cargo':
          this.reloadComboPosition.emit();
          break;
        case 'eps':
          this.reloadComboEps.emit();
          break;
        case 'arl':
          this.reloadComboArl.emit();
          break;
      }
    });
  }

  fileChange($event, file) {
    if (file == 'photo') {
      if ($event['compressor']) {
        this.files[file] = $event['compressor'];
      } else {
        this.files[file] = $event['new'];
      }
      this.fileInput.label = $event['new']['name'];
    } else {
      this.files[file] = $event['new'];
      this.fileInputCv.label = $event['new']['name'];
    }
  }

  openCV() {
    event.preventDefault();
    let ancho: number = 800;
    let alto: number = 700;
    var x: number = screen.width / 2 - ancho / 2;
    var y: number = screen.height / 2 - alto / 2;
    window.open(
      this.curriculumVitae,
      'popup',
      'width=' + ancho + ', height=' + alto + ', left=' + x + ', top=' + y + ''
    );
  }

  back($event) {
    $event.preventDefault();
    setTimeout(() => {
      this.router.navigate(['administracion/usuarios']);
    }, 500);
  }

  private setupEmailValidators() {
    const emailControl = this.userForm.get('email');    
    emailControl?.setValidators([Validators.email]);
    emailControl?.updateValueAndValidity();
  }

  public async emailChanged(email: string) {
    if (email && email.length > 3) {
      const currentUserId = this.tipoRedireccion === 'actualizar' ? this.user?.userId : undefined;
      
      this.hasEmailDuplicateError = false;
      
      this.validateIfEmailExists = await this.userService.validateEmail(email, currentUserId, true);
      
      if (this.validateIfEmailExists.emailExists) {
        this.hasEmailDuplicateError = true;
      }
    } else if (email && email.length <= 3) {
      this.hasEmailDuplicateError = false;
    }
  }
}
